import axios, {AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken} from 'axios';
import {SafeDigsClientBase, isAxiosError, throwException} from './SafeDigsClientBase';
import MNSwagClientConfiguration from '../Toolkit/Api/NSwagClientConfiguration';

export class RegistrationClient extends SafeDigsClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: MNSwagClientConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl('');

    }

    /**
     * @return Success
     */
    registrationData(id: number, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Registration/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegistrationData(_response);
        });
    }

    protected processRegistrationData(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404 !== undefined ? resultData404 : null as any;

            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Success
     */
    listRegistrations(noticeId: number, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Registration/List/{noticeId}";
        url_ = url_.replace("{noticeId}", encodeURIComponent("" + noticeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListRegistrations(_response);
        });
    }

    protected processListRegistrations(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @return Success
     */
    listAllRegistrations( cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Registration/ListAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListAllRegistrations(_response);
        });
    }

    protected processListAllRegistrations(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param body (optional)
     * @return Created
     */
    create(body: RegistrationCreateDto | undefined, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Registration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = resultData201 !== undefined ? resultData201 : null as any;

            return Promise.resolve<any>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: RegistrationUpdateDto | undefined, cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + "/Registration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404 !== undefined ? resultData404 : null as any;

            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }
}

export class RegistrationCreateDto implements IRegistrationCreateDto {
    noticeId?: number;
    digLocation?: string | undefined;
    reinstatementDate?: Date | undefined;
    digLength?: number | undefined;
    digWidth?: number | undefined;
    digDepth?: number | undefined;
    eastings?: number | undefined;
    northings?: number | undefined;
    eastings2?: number | undefined;
    northings2?: number | undefined;
    tempPerm?: boolean | undefined;
    surfaceType?: number | undefined;

    constructor(data?: IRegistrationCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noticeId = _data["noticeId"];
            this.digLocation = _data["digLocation"];
            this.reinstatementDate = _data["reinstatementDate"] ? new Date(_data["reinstatementDate"].toString()) : undefined as any;
            this.digLength = _data["digLength"];
            this.digWidth = _data["digWidth"];
            this.digDepth = _data["digDepth"];
            this.eastings = _data["eastings"];
            this.northings = _data["northings"];
            this.eastings2 = _data["eastings2"];
            this.northings2 = _data["northings2"];
            this.tempPerm = _data["tempPerm"];
            this.surfaceType = _data["surfaceType"];
        }
    }

    static fromJS(data: any): RegistrationCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noticeId"] = this.noticeId;
        data["digLocation"] = this.digLocation;
        data["reinstatementDate"] = this.reinstatementDate ? this.reinstatementDate.toISOString() : undefined as any;
        data["digLength"] = this.digLength;
        data["digWidth"] = this.digWidth;
        data["digDepth"] = this.digDepth;
        data["eastings"] = this.eastings;
        data["northings"] = this.northings;
        data["eastings2"] = this.eastings2;
        data["northings2"] = this.northings2;
        data["tempPerm"] = this.tempPerm;
        data["surfaceType"] = this.surfaceType;
        return data;
    }
}

export interface IRegistrationCreateDto {
    noticeId?: number;
    digLocation?: string | undefined;
    reinstatementDate?: Date | undefined;
    digLength?: number | undefined;
    digWidth?: number | undefined;
    digDepth?: number | undefined;
    eastings?: number | undefined;
    northings?: number | undefined;
    eastings2?: number | undefined;
    northings2?: number | undefined;
    tempPerm?: boolean | undefined;
    surfaceType?: number | undefined;
}

export class RegistrationUpdateDto implements IRegistrationUpdateDto {
    id?: number;
    noticeId?: number;
    digNumber?: number;
    digLocation?: string | undefined;
    reinstatementDate?: Date | undefined;
    digLength?: number | undefined;
    digWidth?: number | undefined;
    digDepth?: number | undefined;
    eastings?: number | undefined;
    northings?: number | undefined;
    eastings2?: number | undefined;
    northings2?: number | undefined;
    tempPerm?: boolean | undefined;
    surfaceType?: number | undefined;
    regStatus?: number | undefined;
    comments?: string | undefined;

    constructor(data?: IRegistrationUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.noticeId = _data["noticeId"];
            this.digNumber = _data["digNumber"];
            this.digLocation = _data["digLocation"];
            this.reinstatementDate = _data["reinstatementDate"] ? new Date(_data["reinstatementDate"].toString()) : undefined as any;
            this.digLength = _data["digLength"];
            this.digWidth = _data["digWidth"];
            this.digDepth = _data["digDepth"];
            this.eastings = _data["eastings"];
            this.northings = _data["northings"];
            this.eastings2 = _data["eastings2"];
            this.northings2 = _data["northings2"];
            this.tempPerm = _data["tempPerm"];
            this.surfaceType = _data["surfaceType"];
            this.regStatus = _data["refStatus"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): RegistrationUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegistrationUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["noticeId"] = this.noticeId;
        data["digNumber"] = this.digNumber;
        data["digLocation"] = this.digLocation;
        data["reinstatementDate"] = this.reinstatementDate ? this.reinstatementDate.toISOString() : undefined as any;
        data["digLength"] = this.digLength;
        data["digWidth"] = this.digWidth;
        data["digDepth"] = this.digDepth;
        data["eastings"] = this.eastings;
        data["northings"] = this.northings;
        data["eastings2"] = this.eastings2;
        data["northings2"] = this.northings2;
        data["tempPerm"] = this.tempPerm;
        data["surfaceType"] = this.surfaceType;
        data["regStatus"] = this.regStatus;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IRegistrationUpdateDto {
    id?: number;
    noticeId?: number;
    digNumber?: number;
    digLocation?: string | undefined;
    reinstatementDate?: Date | undefined;
    digLength?: number | undefined;
    digWidth?: number | undefined;
    digDepth?: number | undefined;
    eastings?: number | undefined;
    northings?: number | undefined;
    eastings2?: number | undefined;
    northings2?: number | undefined;
    tempPerm?: boolean | undefined;
    surfaceType?: number | undefined;
    regStatus?: number | undefined;
    comments?: string | undefined;
}